export const getNumbericLabel = (label: string) => {
  const NUMERIC_REGEXP = /[-]{0,1}[\d]*[.]{0,1}[\d]+/g;

  return label.match(NUMERIC_REGEXP)?.join();
};
